export default __webpack_public_path__ + "static/media/step6.71946d46.png";